<wms-dialog-header (onClose)="closeModal()" title="{{locale.LABEL_PUBLISH_PREFAB_TEAM}}"></wms-dialog-header>
<wms-dialog-body>
  <wms-wizard [counter]="stepCounter" [steps]="steps" *ngIf="!isPublishSuccessful"></wms-wizard>
  <div class="wms-wizard-body">
    <div class="wms-wizard-title" *ngIf="currentStep?.description && !isPublishSuccessful"><span title="{{currentStep?.description}}" class="col-xs-12">{{currentStep?.description}}</span></div>
    <ng-template class="wms-wizard-body-content" [ngTemplateOutlet]="currentStep?.stepTemplate"></ng-template>
  </div>
</wms-dialog-body>
<wms-dialog-footer>
  <button (click)="closeModal()" *ngIf="!isPublishSuccessful && !draftAlert" [disabled]="isFinalStep() && processing" class="btn app-button button-secondary" title="{{locale.LABEL_CANCEL}}">{{locale.LABEL_CANCEL}}</button>
  <button name="btn-prev-page" *ngIf="!isPublishSuccessful && !draftAlert && stepCounter !== 0" [disabled]="isFinalStep() && processing" (click)="decrementStep()" class="btn app-button button-tertiary" title="{{locale.LABEL_BACK}}">{{locale.LABEL_BACK}}</button>
  <button name="btn-next-page" *ngIf="!isPublishSuccessful && !draftAlert" [disabled]="isValid() || validatingVersion || (isFinalStep() && processing)" (click)="incrementStep()" class="btn button-primary">{{nextBtnText}}</button>
  <button name="cancel-prefab-publish" (click)="closeModal()" *ngIf="isPublishSuccessful || draftAlert" class="btn app-button button-secondary" title="{{locale.LABEL_CLOSE}}"><span class="btn-caption">{{locale.LABEL_CLOSE}}</span></button>
</wms-dialog-footer>

<ng-template #informationScreen>
  <wms-ptt-information [artifactPublishDetails]="artifactPublishDetails" [categories]="categories" [dependencies]="dependencies"
                       [isNewArtifact]="isNewArtifact" [artifactDetails]="artifactDetails"
                       [processing]="processing" [draftAlert]="draftAlert"></wms-ptt-information>
</ng-template>

<ng-template #configurationScreen>
  <wms-ptt-configuration [artifactPublishDetails]="artifactPublishDetails"></wms-ptt-configuration>
</ng-template>

<ng-template #documentationScreen>
  <wms-ptt-documentation [documentationUrl]="documentationUrl"></wms-ptt-documentation>
</ng-template>

<ng-template #summaryScreen>
  <wms-ptt-summary [artifactPublishDetails]="artifactPublishDetails" [isPublishSuccessful]="isPublishSuccessful"
                   [showErrMsg]="showErrMsg" [errMsg]="errMsg" [successMessage]="successMessage"></wms-ptt-summary>
</ng-template>
